(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-post-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__p3BlogPostSubmitBound) return;
    window.__p3BlogPostSubmitBound = true;

    const MOBILE_BREAKPOINT = 749;
    const sidebarBySection = new WeakMap();

    const trimLeadingEmptyParagraphs = () => {
      document.querySelectorAll('.p3-blog-post-v1__content').forEach((content) => {
        let firstNode = content.firstElementChild;

        while (firstNode && firstNode.tagName === 'P') {
          const text = firstNode.textContent.replace(/\u00A0/g, '').trim();
          const hasMedia = firstNode.querySelector('img, video, iframe, embed, object');
          const childElements = Array.from(firstNode.children);
          const hasOnlyLineBreaks = childElements.length > 0 && childElements.every((child) => child.tagName === 'BR');

          if (text !== '' || hasMedia || (!hasOnlyLineBreaks && childElements.length > 0)) {
            break;
          }

          const nextNode = firstNode.nextElementSibling;
          firstNode.remove();
          firstNode = nextNode;
        }
      });
    };

    const getMobileYoutubeSrc = (rawSrc) => {
      let parsedUrl;

      try {
        parsedUrl = new URL(rawSrc, window.location.origin);
      } catch (error) {
        return null;
      }

      const host = parsedUrl.hostname.toLowerCase();
      const isYoutubeHost = /(youtube\.com|youtube-nocookie\.com|youtu\.be)$/.test(host);
      if (!isYoutubeHost) return null;

      let videoId = '';
      if (host.endsWith('youtu.be')) {
        videoId = parsedUrl.pathname.replace(/^\/+/, '').split('/')[0];
      } else if (parsedUrl.pathname.includes('/embed/')) {
        videoId = parsedUrl.pathname.split('/embed/')[1].split('/')[0];
      } else {
        videoId = parsedUrl.searchParams.get('v') || '';
      }

      const embedUrl = videoId
        ? new URL(`https://www.youtube-nocookie.com/embed/${videoId}`)
        : new URL(parsedUrl.toString());

      const startParam = parsedUrl.searchParams.get('start') || parsedUrl.searchParams.get('t');
      const listParam = parsedUrl.searchParams.get('list');

      if (startParam) {
        const normalizedStart = String(startParam).replace(/s$/i, '');
        embedUrl.searchParams.set('start', normalizedStart);
      }
      if (listParam) {
        embedUrl.searchParams.set('list', listParam);
      }

      embedUrl.searchParams.set('playsinline', '1');
      embedUrl.searchParams.set('modestbranding', '1');
      embedUrl.searchParams.set('rel', '0');
      embedUrl.searchParams.set('iv_load_policy', '3');
      embedUrl.searchParams.set('controls', '0');
      embedUrl.searchParams.set('fs', '0');
      embedUrl.searchParams.set('disablekb', '1');
      embedUrl.searchParams.set('showinfo', '0');

      return embedUrl.toString();
    };

    const updateMobileYoutubeEmbeds = () => {
      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

      document.querySelectorAll('.p3-blog-post-v1 iframe').forEach((iframe) => {
        const currentSrc = iframe.getAttribute('src');
        if (!currentSrc) return;

        if (!iframe.dataset.p3OriginalSrc) {
          iframe.dataset.p3OriginalSrc = currentSrc;
        }

        const originalSrc = iframe.dataset.p3OriginalSrc;

        if (/embed\.podcasts\.apple\.com/i.test(originalSrc) && !iframe.dataset.p3PodcastPatched) {
          const patchedIframe = document.createElement('iframe');
          Array.from(iframe.attributes).forEach(({ name, value }) => patchedIframe.setAttribute(name, value));
          patchedIframe.setAttribute('allow', 'autoplay *; encrypted-media *; fullscreen *; clipboard-write');
          patchedIframe.setAttribute('sandbox', 'allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation');
          patchedIframe.setAttribute('frameborder', '0');
          const podcastHeight = iframe.getAttribute('height') || '175';
          patchedIframe.style.setProperty('height', podcastHeight + 'px', 'important');
          patchedIframe.dataset.p3PodcastPatched = 'true';
          patchedIframe.className = (patchedIframe.className ? patchedIframe.className + ' ' : '') + 'p3-podcast-embed__iframe';

          const podcastUrl = originalSrc.replace('embed.podcasts.apple.com', 'podcasts.apple.com');
          const link = document.createElement('a');
          link.href = podcastUrl;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.className = 'p3-hover-button p3-podcast-embed__fallback';
          link.style.cssText = '--p3-btn-bg:transparent;--p3-btn-text:white;--p3-btn-border:white;--p3-btn-hover-bg:white;--p3-btn-hover-text:#222222;--p3-btn-hover-border:white;--p3-btn-icon-bg:#222222;--p3-btn-icon-arrow:white;';
          const span = document.createElement('span');
          span.className = 'p3-hover-button__text';
          span.textContent = 'Listen on Apple Podcasts';
          link.appendChild(span);

          const wrapper = document.createElement('div');
          wrapper.className = 'p3-podcast-embed';
          wrapper.appendChild(patchedIframe);
          wrapper.appendChild(link);
          iframe.parentNode.replaceChild(wrapper, iframe);
          return;
        }

        if (/open\.spotify\.com\/embed\//i.test(originalSrc) && !iframe.dataset.p3PodcastPatched) {
          const parentSection = iframe.closest('.p3-blog-post-v1');
          const isPodcastPage = Boolean(parentSection && parentSection.dataset.isPodcast === 'true');

          if (isPodcastPage) {
            const patchedIframe = document.createElement('iframe');
            Array.from(iframe.attributes).forEach(({ name, value }) => patchedIframe.setAttribute(name, value));
            patchedIframe.setAttribute('frameborder', '0');
            const podcastHeight = iframe.getAttribute('height') || '352';
            patchedIframe.style.setProperty('height', podcastHeight + 'px', 'important');
            patchedIframe.dataset.p3PodcastPatched = 'true';
            patchedIframe.className = (patchedIframe.className ? patchedIframe.className + ' ' : '') + 'p3-podcast-embed__iframe';

            const podcastUrl = originalSrc.replace('open.spotify.com/embed/', 'open.spotify.com/');
            const link = document.createElement('a');
            link.href = podcastUrl;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.className = 'p3-hover-button p3-podcast-embed__fallback';
            link.style.cssText = '--p3-btn-bg:transparent;--p3-btn-text:white;--p3-btn-border:white;--p3-btn-hover-bg:white;--p3-btn-hover-text:#222222;--p3-btn-hover-border:white;--p3-btn-icon-bg:#222222;--p3-btn-icon-arrow:white;';
            const span = document.createElement('span');
            span.className = 'p3-hover-button__text';
            span.textContent = 'Listen on Spotify';
            link.appendChild(span);

            const wrapper = document.createElement('div');
            wrapper.className = 'p3-podcast-embed';
            wrapper.appendChild(patchedIframe);
            wrapper.appendChild(link);
            iframe.parentNode.replaceChild(wrapper, iframe);
          }

          return;
        }

        if (!/(youtube\.com|youtube-nocookie\.com|youtu\.be)/i.test(originalSrc)) return;

        if (!isMobile) {
          if (iframe.dataset.p3MobileSrc && currentSrc === iframe.dataset.p3MobileSrc) {
            swapIframeSrc(iframe, originalSrc);
          }
          return;
        }

        const mobileSrc = getMobileYoutubeSrc(originalSrc);
        if (!mobileSrc) return;

        // Set before the swap: the clone carries the data attributes over.
        iframe.dataset.p3MobileSrc = mobileSrc;
        if (currentSrc !== mobileSrc) {
          swapIframeSrc(iframe, mobileSrc);
        }
      });
    };

    // Swap the element instead of setting src on the live iframe: WebKit adds a
    // session history entry for every src change of an existing frame, so the
    // back button only rewound those changes and the reader could not leave the
    // article (PMNS-130). A fresh iframe never adds one. Returns the new frame.
    const swapIframeSrc = (iframe, src) => {
      const replacement = iframe.cloneNode(false);
      replacement.setAttribute('src', src);
      iframe.parentNode.replaceChild(replacement, iframe);
      return replacement;
    };

    const relocateMobileSidebar = () => {
      document.querySelectorAll('.p3-blog-post-v1').forEach((blogSection) => {
        const anchor = blogSection.querySelector('.p3-blog-post-v1__sidebar-anchor');
        if (!anchor) return;

        let sidebar = blogSection.querySelector('.p3-blog-post-v1__sidebar') || sidebarBySection.get(blogSection);
        if (!sidebar) return;
        // Open sheets sit under <body> until closed (see openModal).
        if (sidebar.dataset.p3SheetOpen === 'true') return;

        sidebarBySection.set(blogSection, sidebar);

        const sectionWrapper = blogSection.closest('.shopify-section');
        let nextSection = sectionWrapper ? sectionWrapper.nextElementSibling : null;
        let insightsWrapper = null;

        while (nextSection) {
          if (nextSection.querySelector('.p3-insights-grid')) {
            insightsWrapper = nextSection;
            break;
          }
          nextSection = nextSection.nextElementSibling;
        }

        const shouldMove = window.innerWidth <= MOBILE_BREAKPOINT && Boolean(insightsWrapper);

        if (shouldMove) {
          if (
            sidebar.parentElement !== insightsWrapper.parentElement ||
            sidebar.previousElementSibling !== insightsWrapper
          ) {
            insightsWrapper.insertAdjacentElement('afterend', sidebar);
          }
          sidebar.classList.add('p3-blog-post-v1__sidebar--moved');
        } else {
          if (anchor.parentElement && anchor.nextElementSibling !== sidebar) {
            anchor.insertAdjacentElement('afterend', sidebar);
          }
          sidebar.classList.remove('p3-blog-post-v1__sidebar--moved');
        }
      });
    };

    document.addEventListener('click', (event) => {
      const submitTrigger = event.target.closest('.p3-blog-post-v1__btn');
      if (!submitTrigger) return;

      const parentForm = submitTrigger.closest('form');
      if (!parentForm) return;

      event.preventDefault();

      if (typeof parentForm.requestSubmit === 'function') {
        parentForm.requestSubmit();
      } else {
        parentForm.submit();
      }
    });

    // iOS Safari ignores overflow: hidden for touch scrolling (the page behind
    // the sheet kept moving) and jumps to the top when it is set on <html>.
    // Pin the body at the current offset instead and put the page back with
    // an instant scroll on close (the html element uses scroll-behavior: smooth).
    let lockedScrollY = null;

    const lockPageScroll = () => {
      if (lockedScrollY !== null) return;
      lockedScrollY = window.scrollY;
      Object.assign(document.body.style, {
        position: 'fixed',
        top: `-${lockedScrollY}px`,
        left: '0',
        right: '0',
        width: '100%',
      });
    };

    const unlockPageScroll = () => {
      if (lockedScrollY === null) return;
      const scrollY = lockedScrollY;
      lockedScrollY = null;
      Object.assign(document.body.style, { position: '', top: '', left: '', right: '', width: '' });
      window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' });
    };

    // While open, the sheet lives directly under <body>: a z-index or transform
    // on the section wrappers would otherwise keep it under the fixed header
    // and the sticky strategy-call banner (the close button hid behind the logo).
    const sheetPlaceholders = new WeakMap();

    const openModal = (modal) => {
      if (!modal || modal.dataset.p3SheetOpen === 'true') return;
      const placeholder = document.createComment('p3-blog-post-v1 sheet');
      modal.parentNode.insertBefore(placeholder, modal);
      sheetPlaceholders.set(modal, placeholder);
      document.body.appendChild(modal);
      modal.dataset.p3SheetOpen = 'true';
      modal.style.display = 'flex';
      lockPageScroll();
    };

    const closeModal = (modal) => {
      if (!modal) return;

      modal.style.display = 'none';
      if (modal.dataset.p3SheetOpen !== 'true') return;

      delete modal.dataset.p3SheetOpen;
      const placeholder = sheetPlaceholders.get(modal);
      if (placeholder && placeholder.parentNode) {
        placeholder.parentNode.insertBefore(modal, placeholder);
        placeholder.remove();
      }
      sheetPlaceholders.delete(modal);
      unlockPageScroll();
    };

    const modalTrigger = (opener, closer, modalClass) => {
      const modalOpener = document.querySelector(opener);
      const modalCloser = document.querySelector(closer);
      const modal = document.querySelector(modalClass);

      if (modalOpener) {
        modalOpener.addEventListener('click', () => {
          openModal(modal);
        });
      }

      if (modalCloser) {
        modalCloser.addEventListener('click', () => {
          closeModal(modal);
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !modal || modal.style.display !== 'flex') return;

        closeModal(modal);
      });

    };

    const navigateTopics = () => {
      const toc = document.getElementById('p3-blog-post-v1__navigate-list');
      const headings = [...document.querySelectorAll('.p3-blog-post-v1__content h2')];
      const navigateModal = document.querySelector('.p3-blog-post-v1__navigate');

      if (!toc || !headings.length) return;

      const fragment = document.createDocumentFragment();

      const linkMap = new Map();

      headings.forEach((heading, index) => {
        const id =
          heading.id ||
          heading.textContent
            .trim()
            .toLowerCase()
            .replace(/[^\w]+/g, '-');

        heading.id = id;

        const link = document.createElement('a');

        link.href = `#${id}`;
        link.textContent = heading.textContent;

        fragment.appendChild(link);

        linkMap.set(id, link);
      });

      toc.appendChild(fragment);

      let activeId = null;
      let suppressUntil = 0;

      toc.addEventListener('click', (event) => {
        const link = event.target.closest('a');

        if (!link) return;

        event.preventDefault();

        const id = link.getAttribute('href').slice(1);

        const target = document.getElementById(id);

        if (!target) return;

        linkMap.forEach((tocLink) => {
          tocLink.classList.remove('is-active');
        });

        link.classList.add('is-active');
        activeId = id;
        suppressUntil = performance.now() + 1000;

        // Close first: while the sheet is open the body is pinned, so the page
        // offset reads 0 and the target position would be wrong; closing also
        // restores the page offset instantly, which the smooth scroll below starts from.
        closeModal(navigateModal);

        const offset = 80;

        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top,
          behavior: 'smooth',
        });
      });

      const observer = new IntersectionObserver(
        (entries) => {
          if (performance.now() < suppressUntil) return;

          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const id = entry.target.id;

            if (activeId === id) return;

            activeId = id;

            linkMap.forEach((link) => {
              link.classList.remove('is-active');
            });

            linkMap.get(id)?.classList.add('is-active');
          });
        },
        {
          rootMargin: '-20% 0px -70% 0px',
          threshold: 0,
        }
      );

      headings.forEach((heading) => {
        observer.observe(heading);
      });
    };

    const renderCustomCards = () => {
      const container = document.getElementById('blog-post__custom-cards');
      if (!container) return;

      const cards = window.__blogCustomCards__;
      if (!cards || !cards.length) {
        container.style.display = 'none';
        return;
      }

      const html = cards.map(card => `
        <div class="blog-post__custom-card">
          <h6 class="blog-post__custom-card-tag">${card.tag}</h6>
          <h4 class="blog-post__custom-card-title">${card.title}</h4>
          <p>${card.text}</p>
          <a href="${card.link.url}" class="p3-hover-button blog-post__custom-card-link" style="
            --p3-btn-bg: transparent;
            --p3-btn-text: white;
            --p3-btn-border: white;
            --p3-btn-hover-bg: white;
            --p3-btn-hover-text: #222222;
            --p3-btn-hover-border: white;
            --p3-btn-icon-bg: #222222;
            --p3-btn-icon-arrow: white;
          ">
          <span class="p3-hover-button__text">${card.link.text}</span>
            <svg class="p3-hover-button__icon" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="43.41343688964844" height="43.41343688964844" rx="21.7067" fill="var(--p3-btn-icon-bg)"></rect>
              <g clip-path="url(#clip0_p3_btn)">
                <path d="M28.6035 28.7773H27.1035V17.3711L15.9268 28.5479L14.8662 27.4873L26.043 16.3105H14.6367V14.8105H28.6035V28.7773Z" fill="var(--p3-btn-icon-arrow)"></path>
              </g>
              <defs>
                <clipPath id="clip0_p3_btn">
                  <rect width="15.4134" height="15.4134" fill="white" transform="translate(14 14)"></rect>
                </clipPath>
              </defs>
            </svg>
          </a>
        </div>
      `).join('');

      container.innerHTML = html;
    };

    const renderSlider = () => {
      const container = document.getElementById('blog-post__image-carousel');
      if (!container) return;

      const images = window.__blogSliderImages__;
      if (!images || !images.length) {
        container.style.display = 'none';
        return;
      }

      container.innerHTML = `
        <div class="blog-post__slider">
          <button class="blog-post__slider-btn blog-post__slider-btn--prev" aria-label="Previous">
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 0.5L0.5 4L4 7.5M0.5 4H7.5" stroke="#A3A3A3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>  
          </button>
          <div class="blog-post__slider-wrapper">
            <div class="blog-post__slider-track">
              ${images.map(img => `
                <div class="blog-post__slide">
                  <img src="${img.url}" alt="${img.alt}" loading="lazy" />
                </div>
              `).join('')}
            </div>
          </div>
          <button class="blog-post__slider-btn blog-post__slider-btn--next" aria-label="Next">
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.5 4H7.5M4 7.5L7.5 4L4 0.5" stroke="#A3A3A3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      `;

      const track = container.querySelector('.blog-post__slider-track');
      const prevBtn = container.querySelector('.blog-post__slider-btn--prev');
      const nextBtn = container.querySelector('.blog-post__slider-btn--next');
      const slides = container.querySelectorAll('.blog-post__slide');

      let current = 0;

      const getVisibleCount = () => window.innerWidth <= 749 ? 1 : 3;

      const getSlideWidth = () => {
        const slide = slides[0];
        const gap = 20;
        return slide.offsetWidth + gap;
      };

      const updateButtons = () => {
        const visibleCount = getVisibleCount();
        prevBtn.disabled = current === 0;
        nextBtn.disabled = current >= slides.length - visibleCount;
      };

      const goTo = (index) => {
        current = index;
        track.style.transform = `translateX(-${current * getSlideWidth()}px)`;
        updateButtons();
      };

      prevBtn.addEventListener('click', () => {
        if (current > 0) goTo(current - 1);
      });

      nextBtn.addEventListener('click', () => {
        if (current < slides.length - getVisibleCount()) goTo(current + 1);
      });

      window.addEventListener('resize', () => {
        current = 0;
        goTo(0);
      });

      updateButtons();
    };

    const initFaq = () => {
      const container = document.getElementById('p3-blog-post-v1__faq');
      if (!container) return;

      document.querySelectorAll('.blog-post-v1__faq-question').forEach(button => {
        button.addEventListener('click', () => {
          const item = button.closest('.blog-post-v1__faq-item');
          const isOpen = item.classList.contains('is-open');

          document.querySelectorAll('.blog-post-v1__faq-item').forEach(el => {
            el.classList.remove('is-open');
            el.querySelector('.blog-post-v1__faq-question').setAttribute('aria-expanded', 'false');
          });

          if (!isOpen) {
            item.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
          }
        });
      });
    };

    navigateTopics();
    renderCustomCards();
    renderSlider();
    initFaq();
    trimLeadingEmptyParagraphs();
    updateMobileYoutubeEmbeds();
    relocateMobileSidebar();
    modalTrigger('.form-opener', '.form-closer', '.p3-blog-post-v1__sidebar');
    modalTrigger('.navigate-opener', '.navigate-closer', '.p3-blog-post-v1__navigate');
    window.addEventListener('resize', () => {
      updateMobileYoutubeEmbeds();
      relocateMobileSidebar();
    });
    window.addEventListener('orientationchange', () => {
      updateMobileYoutubeEmbeds();
      relocateMobileSidebar();
    });
  })();

  (() => {
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const MOBILE_BREAKPOINT = 749;

    const setError = (input, errorEl, message) => {
      if (errorEl) errorEl.textContent = message;
      input.classList.toggle('p3-blog-post-v1__input--error', Boolean(message));
      input.setAttribute('aria-invalid', message ? 'true' : 'false');
      return !message;
    };

    document.querySelectorAll('form.p3-blog-post-v1__form').forEach((form) => {
      // Set from JS so native constraint validation still guards the form
      // if this script fails to load.
      form.setAttribute('novalidate', 'novalidate');

      const email = form.querySelector('input[type="email"]');
      const emailError = form.querySelector('[data-error-for="email"]');
      const consent = form.querySelector('input[type="checkbox"][name="contact[Consent]"]');
      const consentError = form.querySelector('[data-error-for="consent"]');

      const validateEmail = () => {
        if (!email) return true;
        const value = email.value.trim();
        if (!value) return setError(email, emailError, 'Business email is required.');
        if (!EMAIL_RE.test(value)) {
          return setError(email, emailError, 'Please enter a valid email address (e.g. name@company.com).');
        }
        return setError(email, emailError, '');
      };

      const validateConsent = () => {
        if (!consent) return true;
        return setError(consent, consentError, consent.checked ? '' : 'Please accept the terms to continue.');
      };

      const phone = form.querySelector('input[type="tel"]');
      const phoneError = form.querySelector('[data-error-for="phone"]');

      // Same rules as the p3-form contact form (PMNS-121): the phone is
      // optional, but a typed number has to look like one.
      const phoneProblem = (value) => {
        if (!value) return '';
        if (/[^\d\s+\-()·.]/.test(value)) {
          return 'Phone number contains invalid characters. Use only digits, +, -, spaces, or parentheses.';
        }
        const digits = value.replace(/\D/g, '').length;
        if (digits < 7) return 'Phone number is too short (minimum 7 digits).';
        if (digits > 15) return 'Phone number is too long (maximum 15 digits).';
        return '';
      };

      const validatePhone = () => {
        if (!phone) return true;
        return setError(phone, phoneError, phoneProblem(phone.value.trim()));
      };

      const submitButton = form.querySelector('.p3-blog-post-v1__form-submit');
      let loading = false;
      let loadingTimer = null;

      // Submit stays disabled until the required fields are valid: the business
      // email and the consent box, plus the phone when one is typed.
      const isComplete = () => {
        if (email && !EMAIL_RE.test(email.value.trim())) return false;
        if (consent && !consent.checked) return false;
        if (phone && phoneProblem(phone.value.trim())) return false;
        return true;
      };

      const updateSubmitState = () => {
        if (submitButton) submitButton.disabled = loading || !isComplete();
      };

      // Spinner while the captcha runs and the post goes out. The page normally
      // navigates away; if nothing is posted the button comes back after a while.
      const setLoading = (on) => {
        loading = on;
        window.clearTimeout(loadingTimer);
        if (submitButton) {
          submitButton.classList.toggle('is-loading', on);
          submitButton.setAttribute('aria-busy', on ? 'true' : 'false');
        }
        if (on) loadingTimer = window.setTimeout(() => setLoading(false), 20000);
        updateSubmitState();
      };

      if (email) {
        email.addEventListener('input', validateEmail);
        email.addEventListener('blur', validateEmail);
      }
      if (consent) consent.addEventListener('change', validateConsent);
      if (phone) {
        phone.addEventListener('input', validatePhone);
        phone.addEventListener('blur', validatePhone);
      }

      form.addEventListener('input', updateSubmitState);
      // Autofill and the checkbox report through change, not always input.
      form.addEventListener('change', updateSubmitState);
      // Back/forward cache restores the page as it was left, spinner included.
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) setLoading(false);
        else updateSubmitState();
      });
      updateSubmitState();

      // Capture phase on the document, not a listener on the form: Shopify's
      // captcha script binds its own submit listener to the form that ignores
      // preventDefault() and posts once hCaptcha resolves, so invalid forms went
      // through and the page reloaded before any error could be read. Stopping
      // the event before it reaches the form keeps that listener out (as in p3-form).
      document.addEventListener(
        'submit',
        (event) => {
          if (event.target !== form) return;
          const emailOk = validateEmail();
          const consentOk = validateConsent();
          const phoneOk = validatePhone();
          if (emailOk && consentOk && phoneOk) {
            setLoading(true);
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          const first = form.querySelector('[aria-invalid="true"]');
          if (first) {
            first.focus({ preventScroll: true });
            first.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        },
        true
      );
    });

    // After a submit Shopify reloads the page with the success or error
    // message rendered inside the form. On mobile the form lives in the
    // sidebar modal, so open it; on desktop bring the message into view.
    const message = document.querySelector('.p3-blog-post-v1__form-message');
    if (!message) return;
    const sidebar = message.closest('.p3-blog-post-v1__sidebar');
    if (window.innerWidth <= MOBILE_BREAKPOINT && sidebar) {
      // Same path as the button, so the sheet gets the scroll lock and sits above the header.
      const opener = document.querySelector('.form-opener');
      if (opener) {
        opener.click();
      } else {
        sidebar.style.display = 'flex';
      }
    } else {
      message.scrollIntoView({ block: 'center' });
    }
  })();

  (function () {
    const progressBar = document.getElementById('progressBar');
    const articleContent = document.querySelector('.p3-blog-post-v1__body');

    /* Bundled JS runs on every page — bail out where this section isn't rendered */
    if (!progressBar || !articleContent) return;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(value, max));
    }

    function updateProgress() {
      const rect = articleContent.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const sectionHeight = articleContent.offsetHeight;
      const start = viewportHeight * 0.1;
      const totalScrollable = sectionHeight - start;
      const walked = clamp(start - rect.top, 0, totalScrollable);
      const progress = totalScrollable > 0 ? (walked / totalScrollable) * 100 : 0;
      progressBar.style.width = clamp(progress, 0, 100) + '%';
    }

    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-post"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__p3BlogPostSubmitBound) return;
    window.__p3BlogPostSubmitBound = true;

    const MOBILE_BREAKPOINT = 749;
    const sidebarBySection = new WeakMap();

    const trimLeadingEmptyParagraphs = () => {
      document.querySelectorAll('.p3-blog-post__content').forEach((content) => {
        let firstNode = content.firstElementChild;

        while (firstNode && firstNode.tagName === 'P') {
          const text = firstNode.textContent.replace(/\u00A0/g, '').trim();
          const hasMedia = firstNode.querySelector('img, video, iframe, embed, object');
          const childElements = Array.from(firstNode.children);
          const hasOnlyLineBreaks = childElements.length > 0 && childElements.every((child) => child.tagName === 'BR');

          if (text !== '' || hasMedia || (!hasOnlyLineBreaks && childElements.length > 0)) {
            break;
          }

          const nextNode = firstNode.nextElementSibling;
          firstNode.remove();
          firstNode = nextNode;
        }
      });
    };

    const getMobileYoutubeSrc = (rawSrc) => {
      let parsedUrl;

      try {
        parsedUrl = new URL(rawSrc, window.location.origin);
      } catch (error) {
        return null;
      }

      const host = parsedUrl.hostname.toLowerCase();
      const isYoutubeHost = /(youtube\.com|youtube-nocookie\.com|youtu\.be)$/.test(host);
      if (!isYoutubeHost) return null;

      let videoId = '';
      if (host.endsWith('youtu.be')) {
        videoId = parsedUrl.pathname.replace(/^\/+/, '').split('/')[0];
      } else if (parsedUrl.pathname.includes('/embed/')) {
        videoId = parsedUrl.pathname.split('/embed/')[1].split('/')[0];
      } else {
        videoId = parsedUrl.searchParams.get('v') || '';
      }

      const embedUrl = videoId
        ? new URL(`https://www.youtube-nocookie.com/embed/${videoId}`)
        : new URL(parsedUrl.toString());

      const startParam = parsedUrl.searchParams.get('start') || parsedUrl.searchParams.get('t');
      const listParam = parsedUrl.searchParams.get('list');

      if (startParam) {
        const normalizedStart = String(startParam).replace(/s$/i, '');
        embedUrl.searchParams.set('start', normalizedStart);
      }
      if (listParam) {
        embedUrl.searchParams.set('list', listParam);
      }

      embedUrl.searchParams.set('playsinline', '1');
      embedUrl.searchParams.set('modestbranding', '1');
      embedUrl.searchParams.set('rel', '0');
      embedUrl.searchParams.set('iv_load_policy', '3');
      embedUrl.searchParams.set('controls', '0');
      embedUrl.searchParams.set('fs', '0');
      embedUrl.searchParams.set('disablekb', '1');
      embedUrl.searchParams.set('showinfo', '0');

      return embedUrl.toString();
    };

    const updateMobileYoutubeEmbeds = () => {
      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

      document.querySelectorAll('.p3-blog-post iframe:not([data-p3-card-player])').forEach((iframe) => {
        const currentSrc = iframe.getAttribute('src');
        if (!currentSrc) return;

        if (!iframe.dataset.p3OriginalSrc) {
          iframe.dataset.p3OriginalSrc = currentSrc;
        }

        const originalSrc = iframe.dataset.p3OriginalSrc;
        if (!/(youtube\.com|youtube-nocookie\.com|youtu\.be)/i.test(originalSrc)) return;

        if (!isMobile) {
          if (iframe.dataset.p3MobileSrc && currentSrc === iframe.dataset.p3MobileSrc) {
            swapIframeSrc(iframe, originalSrc);
          }
          return;
        }

        const mobileSrc = getMobileYoutubeSrc(originalSrc);
        if (!mobileSrc) return;

        // Set before the swap: the clone carries the data attributes over.
        iframe.dataset.p3MobileSrc = mobileSrc;
        if (currentSrc !== mobileSrc) {
          swapIframeSrc(iframe, mobileSrc);
        }
      });
    };

    // Swap the element instead of setting src on the live iframe: WebKit adds a
    // session history entry for every src change of an existing frame, so the
    // back button only rewound those changes and the reader could not leave the
    // article (PMNS-130). A fresh iframe never adds one. Returns the new frame.
    const swapIframeSrc = (iframe, src) => {
      const replacement = iframe.cloneNode(false);
      replacement.setAttribute('src', src);
      iframe.parentNode.replaceChild(replacement, iframe);
      return replacement;
    };

    const relocateMobileSidebar = () => {
      document.querySelectorAll('.p3-blog-post').forEach((blogSection) => {
        const anchor = blogSection.querySelector('.p3-blog-post__sidebar-anchor');
        if (!anchor) return;

        let sidebar = blogSection.querySelector('.p3-blog-post__sidebar') || sidebarBySection.get(blogSection);
        if (!sidebar) return;

        sidebarBySection.set(blogSection, sidebar);

        const sectionWrapper = blogSection.closest('.shopify-section');
        let nextSection = sectionWrapper ? sectionWrapper.nextElementSibling : null;
        let insightsWrapper = null;

        while (nextSection) {
          if (nextSection.querySelector('.p3-insights-grid')) {
            insightsWrapper = nextSection;
            break;
          }
          nextSection = nextSection.nextElementSibling;
        }

        const shouldMove = window.innerWidth <= MOBILE_BREAKPOINT && Boolean(insightsWrapper);

        if (shouldMove) {
          if (sidebar.parentElement !== insightsWrapper.parentElement || sidebar.previousElementSibling !== insightsWrapper) {
            insightsWrapper.insertAdjacentElement('afterend', sidebar);
          }
          sidebar.classList.add('p3-blog-post__sidebar--moved');
        } else {
          if (anchor.parentElement && anchor.nextElementSibling !== sidebar) {
            anchor.insertAdjacentElement('afterend', sidebar);
          }
          sidebar.classList.remove('p3-blog-post__sidebar--moved');
        }
      });
    };

    document.addEventListener('click', (event) => {
      const submitTrigger = event.target.closest('.p3-blog-post__btn');
      if (!submitTrigger) return;

      const parentForm = submitTrigger.closest('form');
      if (!parentForm) return;

      event.preventDefault();

      if (typeof parentForm.requestSubmit === 'function') {
        parentForm.requestSubmit();
      } else {
        parentForm.submit();
      }
    });

    const mobilePlayers = new WeakMap();
    const populateMobileVideoCardFromIframe = () => {
      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
      document.querySelectorAll('.p3-blog-post__mobile-video-card[data-mobile-video-card]').forEach((card) => {
        const active = mobilePlayers.get(card);
        if (!isMobile) {
          if (!active) return;
          active.placeholder.replaceWith(active.original);
          active.player.replaceWith(active.thumb);
          if (active.duration) active.duration.hidden = false;
          active.link.setAttribute('href', active.href);
          mobilePlayers.delete(card);
          return;
        }
        if (active) return;
        const section = card.closest('.p3-blog-post');
        const original = section?.querySelector('.p3-blog-post__content iframe[src*="youtube"], .p3-blog-post__content iframe[src*="youtu.be"]');
        const link = card.querySelector('[data-mobile-video-card-link]');
        const thumb = card.querySelector('[data-mobile-video-card-thumb], [data-mobile-video-card-thumb-placeholder]');
        if (!original || !link || !thumb) return;
        const src = new URL(original.src, window.location.origin);
        src.searchParams.set('controls', '1');
        src.searchParams.set('fs', '1');
        src.searchParams.set('playsinline', '1');
        src.searchParams.delete('disablekb');
        src.searchParams.delete('autoplay');
        const player = original.cloneNode(false);
        player.src = src.toString();
        player.dataset.p3CardPlayer = 'true';
        player.title = original.title || 'Video';
        player.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        player.setAttribute('allowfullscreen', '');
        player.className = 'p3-blog-post__mobile-video-card-player';
        player.style.cssText = 'display:block;width:100%;height:auto;aspect-ratio:16/9;border:0;background:#000;';
        const placeholder = document.createComment('');
        original.replaceWith(placeholder);
        thumb.replaceWith(player);
        const duration = card.querySelector('[data-mobile-video-card-duration]');
        const href = link.getAttribute('href');
        if (duration) duration.hidden = true;
        link.removeAttribute('href');
        mobilePlayers.set(card, { original, placeholder, player, thumb, duration, link, href });
      });
    };

    trimLeadingEmptyParagraphs();
    populateMobileVideoCardFromIframe();
    updateMobileYoutubeEmbeds();
    relocateMobileSidebar();
    window.addEventListener('resize', () => {
      populateMobileVideoCardFromIframe();
      updateMobileYoutubeEmbeds();
      relocateMobileSidebar();
    });
    window.addEventListener('orientationchange', () => {
      populateMobileVideoCardFromIframe();
      updateMobileYoutubeEmbeds();
      relocateMobileSidebar();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog-posts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MIN_PERCENT = 10;
    var HIDDEN = 'featured-blog-posts__progress--hidden';

    function setup(section) {
      var scroller = section.querySelector('slideshow-slides');
      var bar = section.querySelector('[data-featured-blog-progress]');
      var thumb = section.querySelector('[data-featured-blog-progress-thumb]');
      if (!bar || !thumb) return;
      if (!scroller) {
        bar.classList.add(HIDDEN);
        return;
      }
      if (bar._p3Bound) return;
      bar._p3Bound = true;

      function update() {
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        bar.classList.toggle(HIDDEN, maxScroll <= 4);
        if (maxScroll <= 4) return;

        // The track spans the same box as the row: from the first card's left
        // edge to the row's right edge. The scroller carries its own gutters.
        var cs = getComputedStyle(scroller);
        var padL = parseFloat(cs.paddingLeft) || 0;
        var padR = parseFloat(cs.paddingRight) || 0;
        var rowRect = scroller.getBoundingClientRect();
        bar.style.width = Math.max(0, rowRect.width - padL - padR) + 'px';
        // Align by measuring: the theme wraps the row in full-width and
        // page-width boxes whose paddings differ, so correct the margin by
        // however far the bar landed from the first card's left edge.
        var targetLeft = rowRect.left + padL;
        var currentMargin = parseFloat(bar.style.marginLeft) || 0;
        bar.style.marginLeft = (currentMargin + targetLeft - bar.getBoundingClientRect().left) + 'px';

        var atEnd = maxScroll - scroller.scrollLeft <= 4;
        var ratio = atEnd ? 1 : Math.min(1, Math.max(0, scroller.scrollLeft / maxScroll));
        thumb.style.width = Math.max(MIN_PERCENT, ratio * 100) + '%';
      }

      // iOS does not fire scroll events reliably through the momentum settle;
      // re-read the position once the gesture is over.
      function settle() {
        [0, 80, 200, 400, 700].forEach(function (ms) { window.setTimeout(update, ms); });
      }

      scroller.addEventListener('scroll', update, { passive: true });
      ['touchend', 'touchcancel', 'scrollend'].forEach(function (name) {
        scroller.addEventListener(name, settle, { passive: true });
      });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
      window.setTimeout(update, 300);
    }

    function init() {
      document.querySelectorAll('.featured-blog-posts').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-about-hero"] && !Shopify.designMode) return;
  try {
    
  class AboutHeroMediaController {
    constructor(button) {
      this.button = button;
      this.wrapper = button.closest('.p3-about-hero__wrapper');
      this.playIcon = button.querySelector('.p3-about-hero__play-icon');
      this.pauseIcon = button.querySelector('.p3-about-hero__pause-icon');
      this.isPlaying = true;
      
      // Check for video
      this.videoId = button.dataset.videoControl;
      this.video = this.videoId ? document.getElementById(this.videoId) : null;
      
      // Check for gif
      this.gif = this.wrapper.querySelector('.p3-about-hero__gif');
      this.canvas = this.wrapper.querySelector('.p3-about-hero__canvas');
      
      if (this.video || this.gif) {
        this.init();
      }
    }

    init() {
      this.button.addEventListener('click', () => this.toggle());
      
      // Initialize icons based on current state
      if (this.video || this.gif) {
        this.pauseIcon.style.display = 'block';
        this.playIcon.style.display = 'none';
      }
    }

    toggle() {
      if (this.isPlaying) {
        this.pause();
      } else {
        this.play();
      }
    }

    play() {
      if (this.video) {
        this.video.play();
      } else if (this.gif && this.canvas) {
        // Show gif, hide canvas
        this.gif.style.display = 'block';
        this.canvas.style.display = 'none';
      }
      
      this.isPlaying = true;
      this.playIcon.style.display = 'none';
      this.pauseIcon.style.display = 'block';
    }

    pause() {
      if (this.video) {
        this.video.pause();
      } else if (this.gif && this.canvas) {
        // Capture current frame to canvas
        const ctx = this.canvas.getContext('2d');
        this.canvas.width = this.gif.naturalWidth || this.gif.width;
        this.canvas.height = this.gif.naturalHeight || this.gif.height;
        ctx.drawImage(this.gif, 0, 0);
        
        // Hide gif, show canvas
        this.gif.style.display = 'none';
        this.canvas.style.display = 'block';
      }
      
      this.isPlaying = false;
      this.playIcon.style.display = 'block';
      this.pauseIcon.style.display = 'none';
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const mediaButtons = document.querySelectorAll('.p3-about-hero__play-pause');
    mediaButtons.forEach(button => new AboutHeroMediaController(button));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-book-strategy-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.querySelector('.p3-strategy-cta__modal');
    if (!modal) return;

    var iframe = modal.querySelector('.p3-hero__modal-iframe');

    function openModal(url) {
      iframe.src = url;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      iframe.src = '';
      document.body.style.overflow = '';
    }

    var btn = document.querySelector('.p3-book-strategy-cta__btn');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(this.href);
      });
    }

    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-calendly-modal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.querySelector('.p3-calendly-modal__modal');
    if (!modal) return;

    var CALENDLY_ORIGIN = 'https://calendly.com';
    var LOAD_TIMEOUT_MS = 15000;

    var iframe = modal.querySelector('.p3-hero__modal-iframe');
    var loadingEl = modal.querySelector('[data-calendly-loading]');
    var errorEl = modal.querySelector('[data-calendly-error]');
    var successEl = modal.querySelector('[data-calendly-success]');
    var retryBtn = modal.querySelector('[data-calendly-retry]');
    var savedScrollY = 0;
    var currentUrl = '';
    var loadTimer = null;
    var calendlyReady = false;

    // Same parameters Calendly's own popup widget adds: Calendly then styles
    // itself for embedding and posts its lifecycle events to this window.
    function embedUrl(url) {
      try {
        var u = new URL(url, window.location.origin);
        u.searchParams.set('embed_domain', window.location.hostname);
        u.searchParams.set('embed_type', 'PopupWidget');
        return u.toString();
      } catch (err) {
        return url;
      }
    }

    function setLoadingState() {
      calendlyReady = false;
      if (loadingEl) loadingEl.hidden = false;
      if (errorEl) errorEl.hidden = true;
      if (successEl) successEl.hidden = true;
      window.clearTimeout(loadTimer);
      loadTimer = window.setTimeout(function () {
        if (!calendlyReady && !modal.hidden && errorEl) errorEl.hidden = false;
      }, LOAD_TIMEOUT_MS);
    }

    function loadCalendly() {
      iframe.src = embedUrl(currentUrl);
      setLoadingState();
    }

    function openModal(url) {
      currentUrl = url;
      savedScrollY = window.scrollY;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      loadCalendly();
    }

    function closeModal() {
      window.clearTimeout(loadTimer);
      modal.hidden = true;
      iframe.src = '';
      if (errorEl) errorEl.hidden = true;
      if (successEl) successEl.hidden = true;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(0, savedScrollY);
      document.documentElement.style.scrollBehavior = '';
    }

    // Calendly lifecycle events (postMessage from calendly.com):
    // profile_page_viewed / event_type_viewed / date_and_time_selected /
    // event_scheduled. The first one proves the embed rendered.
    window.addEventListener('message', function (e) {
      if (e.origin !== CALENDLY_ORIGIN || modal.hidden) return;
      var data = e.data;
      if (!data || typeof data.event !== 'string' || data.event.indexOf('calendly.') !== 0) return;
      calendlyReady = true;
      window.clearTimeout(loadTimer);
      if (errorEl) errorEl.hidden = true;
      if (data.event === 'calendly.event_scheduled') {
        if (successEl) successEl.hidden = false;
        document.dispatchEvent(new CustomEvent('p3:calendly:scheduled', { detail: data.payload || {} }));
      }
    });

    // Any Calendly link anywhere on the page opens in this modal instead of
    // navigating away. Delegated in the capture phase so links added later
    // are covered too, and so section-level handlers (hero, header, CTA
    // banners) that would open their own copy of the modal never run:
    // otherwise two dialogs stack and closing one leaves the other open.
    document.addEventListener(
      'click',
      function (e) {
        var link = e.target && e.target.closest ? e.target.closest('a[href*="calendly.com"]') : null;
        if (!link) return;
        e.preventDefault();
        e.stopPropagation();
        openModal(link.href);
      },
      true
    );

    if (retryBtn) retryBtn.addEventListener('click', loadCalendly);

    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-core-services-scroll"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.querySelector('.p3-core-services__modal');
    if (!modal) return;

    var iframe = modal.querySelector('.p3-hero__modal-iframe');

    function openModal(url) {
      iframe.src = url;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      iframe.src = '';
      document.body.style.overflow = '';
    }

    var btn = document.querySelector('.p3-core-services__mobile-cta-btn');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(this.href);
      });
    }

    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  });

  const scrollContainer = document.querySelector('.p3-core-services__right');
  
  if (scrollContainer) {
    function updateScrollState() {
      const scrollTop = scrollContainer.scrollTop;
      const scrollHeight = scrollContainer.scrollHeight;
      const clientHeight = scrollContainer.clientHeight;
      const scrollBottom = scrollHeight - scrollTop - clientHeight;
      
      if (scrollTop <= 5 && scrollBottom <= 5) {
        scrollContainer.removeAttribute('data-scroll');
      } else if (scrollTop <= 5) {
        scrollContainer.setAttribute('data-scroll', 'top');
      } else if (scrollBottom <= 5) {
        scrollContainer.setAttribute('data-scroll', 'bottom');
      } else {
        scrollContainer.setAttribute('data-scroll', 'middle');
      }
    }
    
    updateScrollState();
    scrollContainer.addEventListener('scroll', updateScrollState);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-cta-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.querySelector('.p3-cta-banner__modal');
    if (!modal) return;

    var iframe = modal.querySelector('.p3-hero__modal-iframe');

    function openModal(url) {
      iframe.src = url;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      iframe.src = '';
      document.body.style.overflow = '';
    }

    var btn = document.querySelector('.p3-cta-banner__btn');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(this.href);
      });
    }

    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const hamburger = document.querySelector('.p3-header__hamburger');
    const closeBtn = document.querySelector('.p3-header__close');
    const mobileMenu = document.querySelector('.p3-header__mobile-menu');

    if (hamburger) {
      hamburger.addEventListener('click', function() {
        mobileMenu.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    // Close mobile menu when clicking outside
    if (mobileMenu) {
      mobileMenu.addEventListener('click', function(e) {
        if (e.target === mobileMenu) {
          mobileMenu.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }

    // Handle dropdown clicks on desktop
    const dropdownTriggers = document.querySelectorAll('[data-dropdown-trigger]');
    dropdownTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const parent = this.closest('.p3-header__menu-item--parent');
        const isActive = parent.classList.contains('active');

        // Close all other dropdowns
        document.querySelectorAll('.p3-header__menu-item--parent').forEach(p => {
          p.classList.remove('active');
        });

        // Toggle current dropdown
        if (!isActive) {
          parent.classList.add('active');
        }
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.p3-header__menu-item--parent')) {
        document.querySelectorAll('.p3-header__menu-item--parent').forEach(parent => {
          parent.classList.remove('active');
        });
      }
    });

    // Book a Call — open hero modal if present on the page
    const heroModal = document.querySelector('.p3-hero__modal');
    if (heroModal) {
      const iframe = heroModal.querySelector('.p3-hero__modal-iframe');

      function openHeroModal(url) {
        iframe.src = url;
        heroModal.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      ['.p3-header__cta-button--rocket', '.p3-header__cta-button--mobile'].forEach(function(sel) {
        document.querySelectorAll(sel).forEach(function(btn) {
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            openHeroModal(this.href);
          });
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-insights-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (section) => {
      const grid = section.querySelector('.p3-insights-grid__grid');
      const progress = section.querySelector('[data-insights-progress]');
      const thumb = section.querySelector('[data-insights-progress-thumb]');
      if (!grid || !progress || !thumb) return;

      let rafId = null;

      const update = () => {
        rafId = null;

        const maxScroll = grid.scrollWidth - grid.clientWidth;
        if (maxScroll <= 2) {
          progress.classList.add('p3-insights-grid__progress--hidden');
          return;
        }

        progress.classList.remove('p3-insights-grid__progress--hidden');

        // Fill from the left, 10% at the start and 100% at the end. The last
        // card snaps by its end (see the stylesheet), so the row reaches
        // maxScroll; the 4px tolerance covers fractional positions (PMNS-106).
        const atEnd = maxScroll - grid.scrollLeft <= 4;
        const ratio = atEnd ? 1 : Math.min(1, Math.max(0, grid.scrollLeft / maxScroll));
        thumb.style.width = `${Math.max(10, ratio * 100)}%`;
      };

      const scheduleUpdate = () => {
        if (rafId != null) return;
        rafId = requestAnimationFrame(update);
      };

      grid.addEventListener('scroll', scheduleUpdate, { passive: true });
      // iOS does not fire scroll events reliably through the momentum and the
      // snap settle, so the bar kept the last value it saw and stopped short of
      // the end. Re-read the position once the gesture is over (PMNS-106).
      const settle = () => [0, 80, 200, 400, 700].forEach((ms) => window.setTimeout(scheduleUpdate, ms));
      ['touchend', 'touchcancel', 'scrollend'].forEach((name) => {
        grid.addEventListener(name, settle, { passive: true });
      });
      window.addEventListener('resize', scheduleUpdate);
      window.addEventListener('load', scheduleUpdate);

      scheduleUpdate();
      window.setTimeout(scheduleUpdate, 0);
    };

    const initAll = () => {
      document.querySelectorAll('[data-p3-insights-grid]').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-pos-trust-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initParallax(sectionEl) {
      var container = sectionEl.querySelector('[data-parallax-container]');
      var items = sectionEl.querySelectorAll('[data-parallax-items] .p3-pos-trust__item');
      if (!container || !items.length) return;

      var ticking = false;
      var lastScrollY = 0;

      /* Alternate items shift in opposite Y directions */
      function applyParallax() {
        var rect = container.getBoundingClientRect();
        var viewH = window.innerHeight;

        /* Progress: 0 when top of container enters viewport bottom, 1 when bottom leaves top */
        var progress = 1 - (rect.bottom / (viewH + rect.height));
        progress = Math.max(-0.5, Math.min(1.5, progress));

        var strength = 30; /* px at full travel */

        items.forEach(function (item, i) {
          /* Even-index items move upward, odd move downward */
          var direction = (i % 2 === 0) ? -1 : 1;
          var offset = direction * progress * strength;
          item.style.transform = 'translateY(' + offset + 'px)';
        });

        ticking = false;
      }

      function onScroll() {
        lastScrollY = window.scrollY;
        if (!ticking) {
          window.requestAnimationFrame(applyParallax);
          ticking = true;
        }
      }

      /* Only run parallax on non-reduced-motion desktops */
      var mediaQuery = window.matchMedia('(min-width: 750px) and (prefers-reduced-motion: no-preference)');

      function handleMedia(mq) {
        if (mq.matches) {
          window.addEventListener('scroll', onScroll, { passive: true });
          applyParallax();
        } else {
          window.removeEventListener('scroll', onScroll);
          items.forEach(function (item) { item.style.transform = ''; });
        }
      }

      mediaQuery.addEventListener('change', handleMedia);
      handleMedia(mediaQuery);
    }

    /* Not every video has a maxresdefault thumbnail — fall back to hqdefault */
    function initPosterFallback(sectionEl) {
      var poster = sectionEl.querySelector('[data-video-poster-fallback]');
      if (!poster) return;

      function useFallback() {
        var fallback = poster.getAttribute('data-video-poster-fallback');
        if (!fallback || poster.src === fallback) return;
        poster.removeAttribute('data-video-poster-fallback');
        poster.src = fallback;
      }

      poster.addEventListener('error', useFallback);
      /* The image may have already failed before this script ran */
      if (poster.complete && poster.naturalWidth === 0) useFallback();
    }

    /* YouTube IFrame API loader (shared by every instance of the section) */
    var ytApiPromise = null;
    function loadYouTubeApi() {
      if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
      if (ytApiPromise) return ytApiPromise;
      ytApiPromise = new Promise(function (resolve) {
        var previous = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = function () {
          if (typeof previous === 'function') previous();
          resolve(window.YT);
        };
        var script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        document.head.appendChild(script);
      });
      return ytApiPromise;
    }

    /* Inline player instead of leaving the site.
       iOS only lets a video start from a user gesture, and it does not carry the
       gesture over to a cross-origin iframe created in the tap handler (that is why
       the video needed a second tap). So the YouTube player is mounted ahead of time
       (once the section is near the viewport) and the tap just calls playVideo(),
       which WebKit accepts as gesture-driven playback. */
    function initInlineVideo(sectionEl) {
      var wrap = sectionEl.querySelector('.p3-pos-trust__video-wrap[data-video-embed]');
      if (!wrap) return;

      var button = wrap.querySelector('[data-video-play]');
      if (!button) return;

      var youtubeId = wrap.getAttribute('data-youtube-id');
      var player = null;
      var playerReady = false;
      var playWhenReady = false;

      function showPlayer() {
        wrap.classList.add('is-playing');
      }

      /* Fallback (Vimeo, API blocked, or tap before the player mounted): the old flow */
      function injectAutoplayIframe() {
        var iframe = document.createElement('iframe');
        iframe.className = 'p3-pos-trust__video-iframe';
        iframe.src = wrap.getAttribute('data-video-embed');
        iframe.setAttribute('title', button.getAttribute('aria-label') || 'Video');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', '');

        wrap.appendChild(iframe);
        showPlayer();
      }

      function mountPlayer(YT) {
        if (player || !wrap.isConnected) return;

        var host = document.createElement('div');
        host.className = 'p3-pos-trust__video-iframe';
        var target = document.createElement('div');
        host.appendChild(target);
        wrap.appendChild(host);

        player = new YT.Player(target, {
          host: 'https://www.youtube-nocookie.com',
          videoId: youtubeId,
          playerVars: {
            rel: 0,
            modestbranding: 1,
            playsinline: 1,
            enablejsapi: 1,
            origin: window.location.origin
          },
          events: {
            onReady: function () {
              var iframe = player.getIframe();
              if (iframe) iframe.setAttribute('title', button.getAttribute('aria-label') || 'Video');
              playerReady = true;
              if (playWhenReady) player.playVideo();
            },
            onStateChange: function (event) {
              if (event.data === YT.PlayerState.PLAYING) showPlayer();
            }
          }
        });
      }

      function preloadPlayer() {
        if (!youtubeId || player) return;
        loadYouTubeApi().then(mountPlayer);
      }

      if (youtubeId) {
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(function (entries) {
            if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
            observer.disconnect();
            preloadPlayer();
          }, { rootMargin: '600px 0px' });
          observer.observe(wrap);
        } else {
          preloadPlayer();
        }
      }

      button.addEventListener('click', function () {
        if (wrap.classList.contains('is-playing')) return;

        if (player && playerReady) {
          showPlayer();
          player.playVideo();
          return;
        }

        if (player) {
          /* Player still mounting: start as soon as it is ready */
          playWhenReady = true;
          showPlayer();
          return;
        }

        injectAutoplayIframe();
      });
    }

    /* Note: javascript blocks are bundled as static JS (Liquid is not rendered here),
       so sections are selected by class and configuration is read from data attributes. */
    function initSections(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.p3-pos-trust').forEach(function (sectionEl) {
        if (sectionEl.dataset.p3PosTrustInit === 'true') return;
        sectionEl.dataset.p3PosTrustInit = 'true';
        initParallax(sectionEl);
        initPosterFallback(sectionEl);
        initInlineVideo(sectionEl);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initSections(document); });
    } else {
      initSections(document);
    }

    /* Theme editor: re-init when this section is re-rendered */
    document.addEventListener('shopify:section:load', function (event) {
      initSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-seo-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSeoArticle(root) {
      var grid = root.querySelector('[data-seo-article-grid]');
      var fill = root.querySelector('[data-seo-progress-fill]');
      var tocLinks = root.querySelectorAll('[data-seo-toc-link]');
      var headings = root.querySelectorAll('[data-seo-heading]');

      function updateProgress() {
        if (!grid || !fill) return;
        var rect = grid.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        var total = rect.height - viewportHeight;
        var scrolled = -rect.top;
        var progress = 0;
        if (total > 0) {
          progress = Math.min(Math.max(scrolled / total, 0), 1);
        } else if (rect.top <= 0) {
          progress = 1;
        }
        fill.style.width = (progress * 100) + '%';
      }

      function setActiveToc(id) {
        tocLinks.forEach(function (link) {
          link.classList.toggle('is-active', link.dataset.seoTocLink === id);
        });
      }

      if ('IntersectionObserver' in window && headings.length && tocLinks.length) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                setActiveToc(entry.target.id);
              }
            });
          },
          { rootMargin: '-20% 0px -70% 0px' }
        );
        headings.forEach(function (heading) {
          observer.observe(heading);
        });
      }

      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    }

    document.querySelectorAll('[data-seo-article]').forEach(initSeoArticle);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-solutions-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFilters(sectionEl) {
      var filterBar = sectionEl.querySelector('[data-solutions-filters]');
      var viewAllBtn = sectionEl.querySelector('[data-filter-view-all]');
      var categoryBtns = sectionEl.querySelectorAll('[data-filter-category]');
      var cards = sectionEl.querySelectorAll('[data-solutions-cards] .p3-solutions-grid__item');
      if (!filterBar || !viewAllBtn || !cards.length) return;

      function setActive(btn) {
        viewAllBtn.classList.toggle('p3-solutions-grid__filter--active', btn === viewAllBtn);
        viewAllBtn.setAttribute('aria-pressed', btn === viewAllBtn ? 'true' : 'false');
        categoryBtns.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('p3-solutions-grid__filter--active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      function applyFilter(category) {
        cards.forEach(function (card) {
          var show = !category || card.getAttribute('data-category') === category;
          card.hidden = !show;
        });
      }

      viewAllBtn.addEventListener('click', function () {
        setActive(viewAllBtn);
        applyFilter(null);
      });

      categoryBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          setActive(btn);
          applyFilter(btn.getAttribute('data-filter-category'));
        });
      });
    }

    function initSections(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.p3-solutions-grid').forEach(function (sectionEl) {
        if (sectionEl.dataset.p3SolutionsInit === 'true') return;
        sectionEl.dataset.p3SolutionsInit = 'true';
        initFilters(sectionEl);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initSections(document); });
    } else {
      initSections(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p3-video-hero"] && !Shopify.designMode) return;
  try {
    
  class HeroVideoController {
    constructor(button) {
      this.button = button;
      this.videoId = button.dataset.videoControl;
      this.video = document.getElementById(this.videoId);
      this.playIcon = button.querySelector('.p3-hero__play-icon');
      this.pauseIcon = button.querySelector('.p3-hero__pause-icon');

      const hero = button.closest('.p3-hero');
      const heroVideos = hero ? Array.from(hero.querySelectorAll('video.p3-hero__video')) : [];
      this.videos = heroVideos.length > 0 ? heroVideos : [this.video];
      this._activeVideo = null;

      if (this.videos.length > 0) {
        this.init();
      }
    }

    visibleVideo() {
      return this.videos.find(video => video.getClientRects().length > 0) || this.videos[0];
    }

    activateVideo(video) {
      if (!video || video.dataset.p3Loaded) return;

      Array.from(video.querySelectorAll('source')).forEach(source => {
        if (source.dataset.src) {
          source.src = source.dataset.src;
        }
      });

      video.dataset.p3Loaded = '1';
      video.load();
      video.play().catch(() => {});
    }

    init() {
      this.button.addEventListener('click', () => this.toggle());

      this.videos.forEach(video => {
        video.addEventListener('play', () => this.syncState());
        video.addEventListener('pause', () => this.syncState());
        video.addEventListener('stalled', () => this.recover());
        video.addEventListener('waiting', () => this.recover());
      });

      this._activeVideo = this.visibleVideo();
      this.activateVideo(this._activeVideo);
      this.syncState();

      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && !this._userPaused) {
          this.videos.forEach(video => {
            if (video.dataset.p3Loaded && video.paused) video.play().catch(() => {});
          });
        }
      });

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const nextVideo = this.visibleVideo();
          if (nextVideo && nextVideo !== this._activeVideo) {
            if (this._activeVideo) this._activeVideo.pause();
            this._activeVideo = nextVideo;
            this.activateVideo(nextVideo);
          }
        }, 150);
      });
    }

    syncState() {
      const isPlaying = !this.visibleVideo().paused;
      this.playIcon.style.display = isPlaying ? 'none' : 'block';
      this.pauseIcon.style.display = isPlaying ? 'block' : 'none';
    }

    toggle() {
      const paused = this.visibleVideo().paused;

      if (paused) {
        this._userPaused = false;
        this.videos.forEach(video => {
          if (video.dataset.p3Loaded) video.play().catch(() => {});
        });
      } else {
        this._userPaused = true;
        this.videos.forEach(video => video.pause());
      }
    }

    recover() {
      if (!this._userPaused) {
        setTimeout(() => {
          this.videos.forEach(video => {
            if (video.dataset.p3Loaded && video.paused) video.play().catch(() => {});
          });
        }, 500);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const videoButtons = document.querySelectorAll('[data-video-control]');
    videoButtons.forEach(button => new HeroVideoController(button));


  });

  } catch(e) { console.error(e); }
})();
})();
